'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const components_navigation_ButtonNav_ButtonNavButton = require('./ButtonNavButton.cjs.js');

const list = "_list_m3vx7_1";
const item = "_item_m3vx7_33";
const styles = {
	list: list,
	item: item
};

const ButtonNav = ({ align, "aria-label": ariaLabel, isButtonFullWidth = false, items, selectedItemKey, onChooseItem = () => {
}, wrap = false }) => {
  return jsxRuntime.jsx("nav", { "aria-label": ariaLabel, "data-zds": true, children: jsxRuntime.jsx("ul", { className: styles.list, "data-align": align, "data-wrap": wrap, "data-button-full-width": isButtonFullWidth, style: { "--item-count": items.length }, "data-zds": true, children: items.map((item) => {
    const isSelected = item.key === selectedItemKey;
    return jsxRuntime.jsx("li", { className: styles.item, "data-button-full-width": isButtonFullWidth, "data-zds": true, children: jsxRuntime.jsx(components_navigation_ButtonNav_ButtonNavButton.ButtonNavButton, { "aria-label": isSelected ? `${item.text}, selected` : item.text, color: "button-nav", hasShadow: false, href: item.href, iconBefore: item.iconBefore, isFullWidth: isButtonFullWidth, isSelected, onClick: (event) => {
      onChooseItem(item, event);
    }, children: item.text }) }, item.key);
  }) }) });
};

exports.ButtonNav = ButtonNav;
//# sourceMappingURL=ButtonNav.cjs.js.map
